import React, { useEffect, useState } from 'react';
import { autoId } from '@workday/upc-common';
import { PasswordTextFieldWithConfirm } from '../../../shared/passwordTextFieldWithConfirm/PasswordTextFieldWithConfirm';
import styles from './change-password.module.scss';
import { useSelector } from 'react-redux';
import { selectUserEmail } from '../../../slices/login.slice';
import { useResetPasswordMutation } from '../../../slices/auth-api.slice';
import { useHistory } from 'react-router-dom';
import { LOGIN_PATH } from '../../../react-router-paths';
import { useTranslation } from 'react-i18next';
import { PrimaryButton } from '@workday/canvas-kit-react/button';
import { ID_PASSWORD_BUTTON } from '../../../autoIds';
import { maskEmail } from '../../../utils/string';

export function ChangePassword() {
    const userEmail = useSelector(selectUserEmail);

    const history = useHistory();

    const { t } = useTranslation('auth');

    const [resetPassword, { isLoading, isSuccess }] = useResetPasswordMutation();

    useEffect(() => {
        if (isSuccess) {
            history.push(LOGIN_PATH);
        }
    }, [history, isSuccess]);

    const [showPasswordErrors, setShowPasswordErrors] = useState(false);
    const [isPasswordValid, setIsValidPassword] = useState(false);
    const [password, setPassword] = useState('');

    function onSubmit(e) {
        e.preventDefault();

        if (isPasswordValid) {
            resetPassword({ email: userEmail, password });
        } else {
            setShowPasswordErrors(true);
        }
    }

    function passwordUpdated(isValid, password) {
        setIsValidPassword(isValid);
        setPassword(password);
    }

    return (
        <>
            <h1 className={styles.title}>{t('ChangePassword.title')}</h1>
            <p className={styles.email}>{maskEmail(userEmail)}</p>
            <form onSubmit={onSubmit}>
                <PasswordTextFieldWithConfirm
                    passwordUpdated={passwordUpdated}
                    setShowPasswordErrors={setShowPasswordErrors}
                    showPasswordErrors={showPasswordErrors}
                    isDisabled={isLoading}
                    shouldAutoFocus={true}
                />
                <PrimaryButton
                    {...autoId(ID_PASSWORD_BUTTON)}
                    disabled={isLoading}
                    marginTop='1.5rem'
                    maxWidth='21rem'
                    size='medium'
                    type='submit'
                    grow={true}>
                    {t('ChangePassword.submitButton')}
                </PrimaryButton>
            </form>
        </>
    );
}
